import { styled } from '@mui/material'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { LottieWrapper } from 'ComponentLibrary/src/atoms/LottieWrapper'
import { LoadingDotsLottie } from 'ComponentLibrary/index'

export const StyledLoadingDotsWrapper = () => <StyledLottieWrapper animationData={LoadingDotsLottie} />

export const StyledLottieWrapper = styled(LottieWrapper)(() => ({
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: '0',
    transform: 'translate(-50%, 0)',
    left: '50%',
    opacity: '50%',
    zIndex: 1,
    cursor: 'default',
    backgroundColor: tokens.ColorBackgroundLight,
}))
